import AerialCatalogue from "./AerialCatalogue";
import AerialFieldDetail from "./AerialFieldDetail";

const AerialSidebar = ({
	activeSidebarTab,
	setActiveSidebarTab,
	sections,
	markersByFieldId,
	selectedField,
	selectedMarker,
	markerOutsideImage,
	placementActive,
	readOnly,
	projectReadOnly,
	isGuest,
	saving,
	onSelectField,
	onBeginPlacement,
	onCancelPlacement,
	onPreviewMarker,
	onSaveMarker,
	onDeleteMarker,
	onViewProjectField,
}) => (
	<aside className="w-full shrink-0 border-r border-gray-300 bg-white md:w-80 lg:w-96">
		<div className="flex border-b border-gray-300">
			<button
				type="button"
				className={`flex-1 px-3 py-3 font-semibold ${activeSidebarTab === "catalogue" ? "border-b-2 border-blue-600 bg-blue-50" : "hover:bg-gray-100"}`}
				onClick={() => setActiveSidebarTab("catalogue")}>
				Catalogue
			</button>
			<button
				type="button"
				className={`flex-1 px-3 py-3 font-semibold ${activeSidebarTab === "detail" ? "border-b-2 border-blue-600 bg-blue-50" : "hover:bg-gray-100"}`}
				onClick={() => setActiveSidebarTab("detail")}>
				Detail
			</button>
		</div>
		{activeSidebarTab === "catalogue" ? (
			<AerialCatalogue
				sections={sections}
				markersByFieldId={markersByFieldId}
				selectedFieldId={selectedField?.id || null}
				readOnly={projectReadOnly}
				isGuest={isGuest}
				onSelectField={onSelectField}
				onBeginPlacement={onBeginPlacement}
				onOpenDetail={() => setActiveSidebarTab("detail")}
			/>
		) : (
			<AerialFieldDetail
				key={`${selectedField?.id || "no-field"}-${selectedMarker ? selectedMarker.id || "pending" : "none"}`}
				field={selectedField}
				marker={selectedMarker}
				markerOutsideImage={markerOutsideImage}
				placementActive={placementActive}
				readOnly={readOnly}
				projectReadOnly={projectReadOnly}
				saving={saving}
				onBeginPlacement={onBeginPlacement}
				onCancelPlacement={onCancelPlacement}
				onPreviewMarker={onPreviewMarker}
				onSaveMarker={onSaveMarker}
				onDeleteMarker={onDeleteMarker}
				onViewProjectField={onViewProjectField}
			/>
		)}
	</aside>
);

export default AerialSidebar;
